import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';

export const Route = createFileRoute('/_private/settings/revenue-lockdowns/')({
  staticData: { isFullWidth: true },
  validateSearch: filterState.parse,
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
